module.exports = __webpack_public_path__ + "static/media/bg4-summer.9a80274a.png";